import { render } from "./BoardMonthlyActivity.vue?vue&type=template&id=850a078e&scoped=true"
import script from "./BoardMonthlyActivity.vue?vue&type=script&lang=js"
export * from "./BoardMonthlyActivity.vue?vue&type=script&lang=js"

import "./BoardMonthlyActivity.vue?vue&type=style&index=0&id=850a078e&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-850a078e"]])

export default __exports__